export default {"src":"/_next/static/media/quadruple-fistbump.90f93c63.svg","height":240,"width":304,"blurWidth":0,"blurHeight":0};